import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import Text from '@ff/ui/Text';
import Icon from '@ff/ui/Icon';
import { isAppOnly } from '~/app/utils/pathUtils';

export default function FXFleetAuthLayout({children}: {children: React.ReactNode}){
  const isApp = isAppOnly();

  return isApp
    ?
    <>
      <H5Header />
      <main>
        {children}
      </main>
    </>
    : 
    <>
      {/* Custom FX Fleet Header - same as main fleet pages */}
      <HeaderContainer>
        <HeaderContent>
          <LogoSection>
            <WhiteIcon name="ff-icon-ff-fx-icon-logo" fontSize="2rem" />
            <HeaderTitle>Faraday X Fleet</HeaderTitle>
          </LogoSection>
        </HeaderContent>
      </HeaderContainer>
      <main>
        {children}
      </main>
    </>
}

const H5Header = styled(Box)(({ theme }) => ({
  height: '46px',
  position: 'fixed',
  top: '0px',
  left: '0px',
  zIndex: theme.zIndices.menubar
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  backgroundColor: 'transparent',
  padding: '0 16px',
  height: '64px',
  display: 'flex',
  alignItems: 'center',
  zIndex: 999,

  [theme.mediaQueries.md]: {
    padding: '0 24px',
  },
}));

const HeaderContent = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const LogoSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

const HeaderTitle = styled(Text)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: '600',
  color: '#ffffff',

  [theme.mediaQueries.md]: {
    fontSize: '18px',
  },
}));

const WhiteIcon = styled(Icon)({
  color: '#ffffff',
  filter: 'brightness(0) saturate(100%) invert(100%)',
});